import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71c8a7c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "staff-auth" }
const _hoisted_2 = { class: "uf-form-item" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "uf-form-item__label" }, [
  /*#__PURE__*/_createTextVNode(" 姓名 "),
  /*#__PURE__*/_createElementVNode("i", null, "*")
], -1))
const _hoisted_4 = { class: "uf-form-item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "uf-form-item__label" }, " 性别 ", -1))
const _hoisted_6 = { class: "uf-form-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "uf-form-item__label" }, [
  /*#__PURE__*/_createTextVNode(" 手机号 "),
  /*#__PURE__*/_createElementVNode("i", null, "*")
], -1))
const _hoisted_8 = { class: "uf-form-item" }
const _hoisted_9 = { class: "house-title" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "uf-form-item__label" }, [
  /*#__PURE__*/_createTextVNode(" 房间 "),
  /*#__PURE__*/_createElementVNode("i", null, "*")
], -1))
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "uf-form-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "uf-form-item__label" }, [
  /*#__PURE__*/_createTextVNode(" 类型 "),
  /*#__PURE__*/_createElementVNode("i", null, "*")
], -1))
const _hoisted_14 = { class: "uf-form-item" }
const _hoisted_15 = { class: "uf-form-item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "uf-form-item__label" }, [
  /*#__PURE__*/_createTextVNode(" 身份证号 "),
  /*#__PURE__*/_createElementVNode("i", null, "*")
], -1))
const _hoisted_17 = { class: "uf-form-item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "uf-form-item__label" }, [
  /*#__PURE__*/_createTextVNode(" 身份证有效期 "),
  /*#__PURE__*/_createElementVNode("i", null, "*")
], -1))
const _hoisted_19 = { class: "uf-form-item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "uf-form-item__label" }, " 身份证照片 ", -1))
const _hoisted_21 = { class: "uf-button" }
const _hoisted_22 = { class: "uf-button--footer" }
const _hoisted_23 = { class: "uf-location__body" }
const _hoisted_24 = { class: "uf-location__info" }
const _hoisted_25 = { class: "uf-button" }
const _hoisted_26 = { class: "uf-button--footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_uf_daterange_picker = _resolveComponent("uf-daterange-picker")!
  const _component_uf_idcard_upload = _resolveComponent("uf-idcard-upload")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_search = _resolveComponent("van-search")!
  const _component_house_tree = _resolveComponent("house-tree")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_form, {
      onSubmit: _ctx.onSubmit,
      onFailed: _ctx.onFailed,
      class: "uf-form",
      "show-error": "",
      "scroll-to-error": "",
      "show-error-message": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_van_field, {
            modelValue: _ctx.formData.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.name) = $event)),
            name: "name",
            placeholder: "请输入",
            maxlength: "20",
            rules: [{ required: true, message: '请填写姓名' }]
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_van_field, {
            modelValue: _ctx.genderPicker.label,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.genderPicker.label) = $event)),
            readonly: "",
            clickable: "",
            placeholder: "请选择",
            "right-icon": "arrow",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.genderPicker.showPicker = true))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_van_field, {
            modelValue: _ctx.formData.mobile,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.mobile) = $event)),
            name: "mobile",
            placeholder: "请输入",
            rules: [
            { required: true, message: '请填写手机号' },
            { pattern: _ctx.validate.mobile.reg, message: _ctx.validate.mobile.msg }
          ]
          }, null, 8, ["modelValue", "rules"])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.houseData, (item, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                (index !== 0)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "house-delete",
                      onClick: ($event: any) => (_ctx.removeHouse(index))
                    }, "删除", 8, _hoisted_11))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_van_field, {
                modelValue: item.house_id.place,
                "onUpdate:modelValue": ($event: any) => ((item.house_id.place) = $event),
                readonly: "",
                clickable: "",
                placeholder: "请选择",
                "right-icon": "arrow",
                rules: [{ required: true, message: '请选择房间' }],
                onClick: ($event: any) => (_ctx.handleHouse(index))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onClick"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_van_field, {
                modelValue: item.house_user_type.label,
                "onUpdate:modelValue": ($event: any) => ((item.house_user_type.label) = $event),
                readonly: "",
                clickable: "",
                placeholder: "请选择",
                "right-icon": "arrow",
                rules: [{ required: true, message: '请选择类型' }],
                onClick: ($event: any) => (item.house_user_type.showPicker = true)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onClick"])
            ]),
            _createVNode(_component_van_popup, {
              show: item.house_user_type.showPicker,
              "onUpdate:show": ($event: any) => ((item.house_user_type.showPicker) = $event),
              position: "bottom",
              "safe-area-inset-bottom": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_picker, {
                  title: "房间类型",
                  columns: item.house_user_type.columns,
                  onConfirm: item.house_user_type.onConfirm,
                  onCancel: item.house_user_type.onCancel,
                  onChange: item.house_user_type.onChange
                }, null, 8, ["columns", "onConfirm", "onCancel", "onChange"])
              ]),
              _: 2
            }, 1032, ["show", "onUpdate:show"])
          ], 64))
        }), 128)),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", {
            class: "add-house",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addHouse && _ctx.addHouse(...args)))
          }, [
            _createVNode(_component_van_icon, {
              name: "plus",
              style: {"margin-right":"5px"}
            }),
            _createTextVNode(" 添加房间")
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createVNode(_component_van_field, {
            modelValue: _ctx.formData.id_card,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.id_card) = $event)),
            name: "id_card",
            placeholder: "请输入",
            rules: [
            {
              required: true,
              validator(value) {
                if (!value) return true;
                return _ctx.validate.isCardID(value);
              },
              message: '请输入正确的身份证号'
            }
          ]
          }, null, 8, ["modelValue", "rules"])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createVNode(_component_van_field, {
            modelValue: _ctx.validityOfIDCard.label,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.validityOfIDCard.label) = $event)),
            readonly: "",
            clickable: "",
            rules: [{ required: true, message: '请选择身份证有效期' }],
            placeholder: "请选择",
            "right-icon": "arrow",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.daterangePickerIsShow = true))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_uf_daterange_picker, {
            show: _ctx.daterangePickerIsShow,
            "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.daterangePickerIsShow) = $event)),
            modelValue: _ctx.daterangePickerData,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.daterangePickerData) = $event))
          }, null, 8, ["show", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createVNode(_component_van_field, null, {
            input: _withCtx(() => [
              _createVNode(_component_uf_idcard_upload, {
                modelValue: _ctx.idcardData,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.idcardData) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_van_button, {
              class: "btn",
              block: "",
              color: "#3d6eeb",
              square: "",
              type: "success",
              "native-type": "submit"
            }, {
              default: _withCtx(() => [
                _createTextVNode("提交认证申请 ")
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "onFailed"]),
    _createVNode(_component_van_popup, {
      show: _ctx.genderPicker.showPicker,
      "onUpdate:show": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.genderPicker.showPicker) = $event)),
      position: "bottom",
      "safe-area-inset-bottom": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          title: "性别选择",
          columns: _ctx.genderPicker.columns,
          onConfirm: _ctx.genderPicker.onConfirm,
          onCancel: _ctx.genderPicker.onCancel,
          onChange: _ctx.genderPicker.onChange
        }, null, 8, ["columns", "onConfirm", "onCancel", "onChange"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: _ctx.houseTypePickker.showPicker,
      "onUpdate:show": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.houseTypePickker.showPicker) = $event)),
      position: "bottom",
      "safe-area-inset-bottom": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          title: "类型选择",
          columns: _ctx.houseTypePickker.columns,
          onConfirm: _ctx.houseTypePickker.onConfirm,
          onCancel: _ctx.houseTypePickker.onCancel,
          onChange: _ctx.houseTypePickker.onChange
        }, null, 8, ["columns", "onConfirm", "onCancel", "onChange"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: _ctx.chooseHouse.show,
      "onUpdate:show": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.chooseHouse.show) = $event)),
      closeable: "",
      position: "bottom",
      round: "",
      style: { height: '95%', width: '100%' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_component_van_nav_bar, { title: "选择房间" }),
          _createVNode(_component_van_search, {
            modelValue: _ctx.chooseHouse.searchName,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.chooseHouse.searchName) = $event)),
            shape: "round",
            placeholder: "搜索",
            onSearch: _cache[14] || (_cache[14] = ($event: any) => (_ctx.chooseHouse.getList()))
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_house_tree, {
              data: _ctx.chooseHouse.list,
              ref: "houseTreeRef"
            }, null, 8, ["data"])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_van_button, {
                block: "",
                class: "btn",
                color: "#3d6eeb",
                square: "",
                type: "success",
                onClick: _ctx.chooseHouse.confirm
              }, {
                default: _withCtx(() => [
                  _createTextVNode("确认 ")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}